import { useEffect } from 'react';

import { Bus } from 'tools';

const useRelatedChartsEvent = ({
  events,
  handler,
}: {
  events: string[];
  enabled?: boolean;
  handler: (v: unknown) => void;
}) => {
  useEffect(() => {
    for (const event of events) {
      Bus.on(event, handler);
    }

    return () => {
      for (const event of events) {
        Bus.off(event, handler);
      }
    };
  }, [events, handler]);
};

export { useRelatedChartsEvent };
